import omit from 'lodash/omit';
import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';

const supportedActions = ['SAVE', 'CLEAR', 'CLEAR_BY_KEY'];

export const consts = createConsts(
  'profile',
  'add-patient-data',
  ...supportedActions,
);
export const actions = createActions(consts);

const initialState = {};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case consts.SAVE:
      return {
        ...state,
        ...payload,
      };
    case consts.CLEAR:
      return initialState;
    case consts.CLEAR_BY_KEY:
      return omit(state, `${payload.key}`);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/profiles/add-patient-data.js